import ContentLoading from "./ContentLoading";
export default ContentLoading;
